/** NodeType
 * generated by enums.tst
**/
var NodeType;
(function (NodeType) {
    NodeType[NodeType["sim"] = 0] = "sim";
    NodeType[NodeType["testplan"] = 1] = "testplan";
    NodeType[NodeType["testcase"] = 2] = "testcase";
    NodeType[NodeType["folder"] = 3] = "folder";
})(NodeType || (NodeType = {}));
/** VerdictType
 * generated by enums.tst
**/
var VerdictType;
(function (VerdictType) {
    VerdictType[VerdictType["failed"] = 0] = "failed";
    VerdictType[VerdictType["passed"] = 1] = "passed";
    VerdictType[VerdictType["inconclusive"] = 2] = "inconclusive";
    VerdictType[VerdictType["suspended"] = 3] = "suspended";
})(VerdictType || (VerdictType = {}));
/** ClearingVerdictType
 * generated by enums.tst
**/
var ClearingVerdictType;
(function (ClearingVerdictType) {
    ClearingVerdictType[ClearingVerdictType["noclearingverdict"] = -1] = "noclearingverdict";
    ClearingVerdictType[ClearingVerdictType["failed"] = 0] = "failed";
    ClearingVerdictType[ClearingVerdictType["passed"] = 1] = "passed";
    ClearingVerdictType[ClearingVerdictType["inconclusive"] = 2] = "inconclusive";
})(ClearingVerdictType || (ClearingVerdictType = {}));
